<script setup lang="ts">
import { AppLink } from '#components'

const { loadLayout, layoutData } = useLayout()
await loadLayout()

const { loadIcon } = useDynamicIcons()

function getElement(to: string | null | undefined) {
  return to ? AppLink : 'span'
}
</script>

<template>
  <div class="assistance">
    <div class="assistance__heading">
      {{ $t('Need help with your order?') }}
    </div>

    <address
      v-if="layoutData?.contact?.[0]?.Items?.length"
      class="assistance__contact"
    >
      <p
        v-for="item in layoutData.contact[0].Items"
        :key="item"
        class="assistance__item"
      >
        <component
          :is="getElement(item.Link)"
          :to="item.Link"
          class="assistance__link"
        >
          <NuxtIcon
            v-if="item.Icon"
            :name="loadIcon(item.Icon)"
          />
          <span class="assistance__label">{{ item.Name }}</span>
        </component>
        <br>
        <span class="assistance__description">{{ item.Description }}</span>
      </p>
    </address>
  </div>
</template>

<style>
@import url("~layers/components/Checkout/Assistance.css");
</style>
